export default {
    palette: {
        text: {
            primary: '#282725',
            secondary: '#765454',
            disabled: 'rgba(40, 39, 37, 0.38)',
            _states: {
                focusVisible: 'rgba(0, 0, 0, 0.3)'
            }
        },
        primary: {
            main: '#831A4A',
            dark: '#4F0B2C',
            light: '#F8BBE0',
            contrastText: '#FFFFFF',
            _states: {
                hover: 'rgba(239, 48, 141, 0.04)',
                selected: 'rgba(239, 48, 141, 0.08)',
                focus: 'rgba(239, 48, 141, 0.12)',
                focusVisible: 'rgba(239, 48, 141, 0.3)',
                outlinedBorder: 'rgba(239, 48, 141, 0.5)'
            }
        },
        secondary: {
            main: '#BE9191',
            dark: '#765454',
            light: '#ECDCCD',
            contrastText: '#FFFFFF',
            _states: {
                focusVisible: 'rgba(156, 39, 176, 0.3)',
                outlinedBorder: 'rgba(156, 39, 176, 0.5)'
            }
        },
        action: {
            active: 'rgba(40, 39, 37, 0.56)',
            hover: 'rgba(40, 39, 37, 0.04)',
            selected: 'rgba(40, 39, 37, 0.08)',
            focus: 'rgba(40, 39, 37, 0.12)',
            disabled: 'rgba(40, 39, 37, 0.38)',
            disabledBackground: 'rgba(40, 39, 37, 0.12)'
        },
        error: {
            main: '#B63932',
            dark: '#B63932',
            light: '#F95647',
            contrastText: '#FFFFFF',
            _states: {
                hover: 'rgba(249, 86, 71, 0.04)',
                selected: 'rgba(249, 86, 71, 0.08)',
                focusVisible: 'rgba(249, 86, 71, 0.3)',
                outlinedBorder: 'rgba(249, 86, 71, 0.5)'
            }
        },
        warning: {
            main: '#B37424',
            dark: '#9D621C',
            light: '#E6A23B',
            contrastText: '#FFFFFF',
            _states: {
                hover: 'rgba(213, 147, 50, 0.04)',
                selected: 'rgba(213, 147, 50, 0.08)',
                focusVisible: 'rgba(213, 147, 50, 0.3)',
                outlinedBorder: 'rgba(213, 147, 50, 0.5)'
            }
        },
        info: {
            contrastText: '#FFFFFF',
            main: '#0288D1',
            _states: {
                outlinedBorder: 'rgba(2, 136, 209, 0.5)'
            }
        },
        success: {
            main: '#6F8A50',
            dark: '#506934',
            light: '#D6DEBA',
            contrastText: '#FFFFFF',
            _states: {
                hover: 'rgba(209, 215, 163, 0.04)',
                selected: 'rgba(209, 215, 163, 0.08)',
                focusVisible: 'rgba(209, 215, 163, 0.3)',
                outlinedBorder: 'rgba(209, 215, 163, 0.5)'
            }
        },
        common: {
            black: '#282725',
            white: '#FFFFFF'
        },
        background: {
            'default': '#FCF4E9',
            'paper-elevation-0': '#ECDCCD'
        },
        divider: '#ECDCCD',
        elevation: {
            outlined: '#ECDCCD'
        },
        _components: {
            avatar: {
                fill: '#393935'
            },
            switch: {
                knobFillEnabled: '#F3F3F2',
                knowFillDisabled: '#E8E8E6',
                slideFill: '#000000'
            },
            chip: {
                defaultEnabledBorder: '#9E9E99'
            },
            appBar: {
                defaultFill: '#E8E8E6'
            },
            breadcrumbs: {
                collapseFill: '#E8E8E6'
            },
            alert: {
                error: {
                    color: '#7D2623',
                    background: '#FFE9E6'
                },
                warning: {
                    color: '#9D621C',
                    background: '#FFF4E0'
                },
                success: {
                    color: '#506934',
                    background: '#F2F5E8'
                }
            },
            stepper: {
                connector: '#9E9E99'
            }
        },
        _native: {
            'scrollbar-bg': '#D4D4D2'
        }
    },
    typography: {
        h1: {
            fontSize: '3rem',
            fontFamily: 'Inferi, Helvetica, Arial, sans-serif',
            fontWeight: 400,
            lineHeight: '56px'
        },
        h2: {
            fontSize: '24px',
            fontFamily: 'Basis Grotesque Pro, Helvetica, Arial, sans-serif',
            fontWeight: 400,
            lineHeight: '68px'
        },
        h3: {
            fontSize: '2rem',
            fontFamily: 'Inferi, Helvetica, Arial, sans-serif',
            lineHeight: '34px'
        },
        h4: {
            fontSize: '1.5rem',
            fontFamily: 'Inferi, Helvetica, Arial, sans-serif',
            lineHeight: '32px'
        },
        h5: {
            fontSize: '18px',
            fontFamily: 'Basis Grotesque Pro, Helvetica, Arial, sans-serif',
            lineHeight: '24px'
        },
        h6: {
            fontSize: '1.125rem',
            fontFamily: 'Basis Grotesque Pro, Helvetica, Arial, sans-serif',
            fontWeight: 700,
            lineHeight: '24px'
        },
        body1: {
            fontFamily: 'Basis Grotesque Pro, Helvetica, Arial, sans-serif',
            lineHeight: '20px'
        },
        body2: {
            fontFamily: 'Basis Grotesque Pro, Helvetica, Arial, sans-serif',
            lineHeight: '16px'
        },
        subtitle1: {
            fontSize: '0.75rem',
            fontFamily: 'Basis Grotesque Pro, Helvetica, Arial, sans-serif',
            lineHeight: '16px'
        },
        subtitle2: {
            fontSize: '0.75rem',
            fontFamily: 'Basis Grotesque Pro, Helvetica, Arial, sans-serif',
            fontWeight: 400,
            lineHeight: '16px'
        },
        overline: {
            fontFamily: 'Basis Grotesque Mono, Helvetica, Arial, sans-serif',
            lineHeight: '16px'
        },
        caption: {
            fontFamily: 'Basis Grotesque Pro, Helvetica, Arial, sans-serif',
            lineHeight: '16px'
        }
    },
    shape: {
        borderRadius: 8
    }
}
